// import { MoneyTransferMobileModule } from './../../modules/account/component/money-transfer/money-transfer-mobile/money-transfer-mobile.module';
// import { NoInternetModule } from './../../modules/no-internet/no-internet.module';
import { NgbModalDismissAllGuard } from 'src/app/shared/guards/ngb-modal-dismiss-all.guard';
// import { AuthGuard } from 'src/app/shared';

export const MOBILE_ROUTES = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        path: 'welcome',
        loadChildren: () => import('../../modules/welcome/welcome.module').then(m => m.WelcomeModule)
    },
    {
        path: 'no-internet',
        loadChildren: () => import('../../modules/modals/no-internet/no-internet.module').then(m => m.NoInternetModule)
    },
    {
        path: 'login',
        loadChildren: () => import('../../modules/login/login.module').then(m => m.LoginModule)
    },
    {
        path: 'otp',
        loadChildren: () => import('../../modules/otp/otp.module').then(m => m.OtpModule)
    },
    {
        path: 'sign-up',
        loadChildren: () => import('../../modules/sign-up/sign-up.module').then(m => m.SignUpModule)
    },
    {
        path: 'select-location',
        // canActivate: [AuthGuard],
        loadChildren: () => import('../../modules/select-location/select-location.module')
            .then(m => m.SelectLocationModule)
    },
    // {
    //     path: 'main',
    //     loadChildren: () => import('../../modules/main-routing/main-mobile/main-mobile.module')
    //         .then(m => m.MainMobileModule),
    // },
    {
        path: 'see-all-dish',
        canActivate: [NgbModalDismissAllGuard],
        loadChildren: () => import('../../modules/see-all-dish/see-all-dish-mobile/see-all-dish-mobile.module')
            .then(m => m.SeeAllDishMobileModule),
    },
    {
        path: 'see-all-restaurants',
        canActivate: [NgbModalDismissAllGuard],
        loadChildren: () => import('../../modules/see-all-restaurants/see-all-restaurants-mobile/see-all-restaurants-mobile.module')
            .then(m => m.SeeAllRestaurantsMobileModule),
    },
    {
        path: 'food-preferences',
        loadChildren: () => import('../../modules/account/component/food-preferences/food-preferences-mobile/food-preferences-mobile.module')
            .then(m => m.FoodPreferencesMobileModule),
    },
    {
        path: 'favorites',
        loadChildren: () => import('../../modules/account/component/favourites/favourites-mobile/favourites-mobile.module')
            .then(m => m.FavouritesMobileModule),
    },
    {
        path: 'manage-address',
        canActivate: [NgbModalDismissAllGuard],
        loadChildren: () => import('../../modules/account/component/manage-address/manage-address-mobile/manage-address-mobile.module')
            .then(m => m.ManageAddressMobileModule),
    },
    {
        path: 'add-edit-address',
        loadChildren: () => import('../../modules/account/component/add-edit-address/add-edit-address-mobile/add-edit-address-mobile.module')
            .then(m => m.AddEditAddressMobileModule),
    },

    {
        path: 'my-wallet',
        loadChildren: () => import('../../modules/account/component/my-wallet/my-wallet-mobile/my-wallet-mobile.module')
            .then(m => m.MyWalletMobileModule),
    },
    {
        path: 'order-confirmation',
        loadChildren: () => import('../../modules/modals/order-confirmation-modal/order-confirmation-modal.module')
            .then(m => m.OrderConfirmationModalModule),
    },
    {
        path: 'money-transfer',
        loadChildren: () => import('../../modules/account/component/money-transfer/money-transfer-mobile/money-transfer-mobile.module')
            .then(m => m.MoneyTransferMobileModule),
    },
    {
        path: 'my-rewards',
        loadChildren: () => import('../../modules/account/component/my-rewards/my-rewards-mobile/my-rewards-mobile.module')
            .then(m => m.MyRewardsMobileModule),
    },
    {
        path: 'scratch-info',
        loadChildren: () => import('../../shared/components/scratch-card-mobile-info/scratch-card-mobile-info.module')
            .then(m => m.ScratchCardMobileInfoModule),
    },
    {
        path: 'order-history',
        canActivate: [NgbModalDismissAllGuard],
        loadChildren: () => import('../../modules/account/component/order-history/order-history-mobile/order-history-mobile.module')
            .then(m => m.OrderHistoryMobileModule),
    },
    {
        path: 'order-details',
        canActivate: [NgbModalDismissAllGuard],
        loadChildren: () => import('../../modules/account/component/order-details-mobile/order-details-mobile.module')
            .then(m => m.OrderDetailsMobileModule),
    },
    {
        path: 'order-tracking',
        canActivate: [NgbModalDismissAllGuard],
        loadChildren: () => import('../../modules/account/component/order-tracking-mobile/order-tracking-mobile.module')
            .then(m => m.OrderTrackingMobileModule),
    },

    {
        path: 'rest-details',
        canActivate: [NgbModalDismissAllGuard],
        loadChildren: () => import('../../modules/restaurant-details/restaurant-details-mobile/restaurant-details-mobile.module')
            .then(m => m.RestaurantDetailsMobileModule),
    },
    {
        path: 'refer-earn',
        loadChildren: () => import('../../modules/account/component/refer-and-earn/refer-and-earn-mobile/refer-and-earn-mobile.module')
            .then(m => m.ReferAndEarnMobileModule),
    },
    {
        path: 'help-faqs',
        loadChildren: () => import('../../modules/account/component/help/help-mobile/help-mobile.module')
            .then(m => m.HelpMobileModule),
    },
    {
        path: 'profile-details',
        loadChildren: () => import('../../modules/account/component/profile-details/profile-details-mobile/profile-details-mobile.module')
            .then(m => m.ProfileDetailsMobileModule),
    },
    {
        path: 'rewards-coupons',
        loadChildren: () => import('../../modules/account/component/my-rewards/components/reward-coupons/reward-coupons-mobile/reward-coupons-mobile.module')
            .then(m => m.RewardCouponsMobileModule),
    },
    {
        path: 'rewards-earned',
        loadChildren: () => import('../../modules/account/component/my-rewards/components/rewards-earned/rewards-earned-mobile/rewards-earned-mobile.module')
            .then(m => m.RewardsEarnedMobileModule),
    },
    {
        path: 'offers',
        loadChildren: () => import('../../modules/offers/offers-mobile/offers-mobile.module')
            .then(m => m.OffersMobileModule),
    },
    {
        path: 'earned-scratch-cards',
        loadChildren: () => import('../../modules/account/component/earned-scratch-cards/earned-scratch-cards-mobile/earned-scratch-cards-mobile.module')
            .then(m => m.EarnedScratchCardsMobileModule),
    },
    {
        path: 'referral',
        loadChildren: () => import('../../modules/referrals/referrals.module').then(m => m.ReferralsModule),
    },
    {
        path: 'home',
        canActivate: [NgbModalDismissAllGuard],
        loadChildren: () => import('../../modules/home/home-mobile/home-mobile.module').then(m => m.HomeMobilePageModule),
    },
    {
        path: 'explore',
        canActivate: [NgbModalDismissAllGuard],
        loadChildren: () => import('../../modules/explore/explore-mobile/explore-mobile.module').then(m => m.ExploreMobileModule),
    },
    {
        path: 'account',
        canActivate: [NgbModalDismissAllGuard],
        loadChildren: () => import('../../modules/account/account-mobile/account-mobile.module')
            .then(m => m.AccountMobileModule),
    },
    {
        path: 'cart',
        canActivate: [NgbModalDismissAllGuard],
        loadChildren: () => import('../../modules/cart/cart-mobile/cart-mobile.module').then(m => m.CartMobileModule),
      },
      {
        path: 'payments',
        canActivate: [NgbModalDismissAllGuard],
        loadChildren: () => import('../../modules/payments/payments.module').then(m => m.PaymentsModule),
      },
      {
        path: '**', redirectTo: 'home'
    }

]